import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 mt-32">
      <div className="container-pad py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="font-display text-2xl tracking-tight">
            Cloud<span className="text-signal">Rent</span>
          </div>
          <p className="mt-3 text-zinc-500 text-sm max-w-md">
            CloudRent is a cloud hosting & developer-API SaaS. Customers rent virtual or
            dedicated servers and subscribe to REST APIs through a single dashboard.
            Software service only — no physical goods are shipped.
          </p>
          <div className="mt-4 font-mono text-[10px] uppercase tracking-widest text-zinc-600">
            // Software service · 100% digital delivery
          </div>
          <div className="mt-4 text-sm text-zinc-400">
            <a href="mailto:support@cloudrentvps.com" className="hover:text-signal" data-testid="footer-support-email">
              support@cloudrentvps.com
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="overline">PRODUCTS</div>
          <ul className="mt-3 space-y-1.5 text-sm text-zinc-400">
            <li><Link to="/catalog?subtype=vps" className="hover:text-white" data-testid="footer-vps-link">VPS Hosting</Link></li>
            <li><Link to="/catalog?subtype=dedicated" className="hover:text-white" data-testid="footer-dedicated-link">Dedicated Servers</Link></li>
            <li><Link to="/catalog?category=api_services" className="hover:text-white" data-testid="footer-apis-link">Developer APIs</Link></li>
            <li><Link to="/pricing" className="hover:text-white" data-testid="footer-pricing-link">Pricing</Link></li>
            <li><Link to="/catalog" className="hover:text-white">Full catalog</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline">RESOURCES</div>
          <ul className="mt-3 space-y-1.5 text-sm text-zinc-400">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about-link">About</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact-link">Contact</Link></li>
            <li><Link to="/status" className="hover:text-white" data-testid="footer-status-link">Status</Link></li>
            <li><Link to="/dashboard" className="hover:text-white">Dashboard</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline">LEGAL</div>
          <ul className="mt-3 space-y-1.5 text-sm text-zinc-400">
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:text-white" data-testid="footer-refund-link">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800">
        <div className="container-pad py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 font-mono text-[10px] uppercase tracking-widest text-zinc-600">
          <span>© 2026 CLOUDRENT</span>
          <span className="text-zinc-500">
            <Link to="/terms" className="hover:text-white">TERMS</Link>
            <span className="mx-2 text-zinc-700">·</span>
            <Link to="/privacy" className="hover:text-white">PRIVACY</Link>
            <span className="mx-2 text-zinc-700">·</span>
            <Link to="/refund" className="hover:text-white">REFUND</Link>
            <span className="mx-2 text-zinc-700">·</span>
            <Link to="/pricing" className="hover:text-white">PRICING</Link>
          </span>
          <span>Build #1.0.0 · Region: GLOBAL</span>
        </div>
      </div>
    </footer>
  );
}
